<app-custom-spinner *ngIf="isLoading"></app-custom-spinner>

<ng-container *ngIf="programInfo$ | async as programInfo">
  <app-brand-header [brandColor]="programInfo.color" [brandLogoUrl]="programInfo.logo" [brandSlug]="programInfo.company_slug"></app-brand-header>

  <div class="top-banner" [style.backgroundImage]="'url(' + programInfo.picture_cover + ')'"></div>

  <div class="container-xl">
    <h1 [style.color]="programInfo.color">{{programInfo.title[currentLanguage]}}</h1>
    <h2 [style.color]="programInfo.color">{{programInfo.subtitle[currentLanguage]}}</h2>
    <div class="description" [innerHTML]="programInfo.description[currentLanguage]"></div>
    <div id="target" #target></div>

    <div class="projects-container" [style.backgroundColor]="getRGBAColor(0.1)">
      <div class="noos-logo" [innerHTML]="getSvgImage()"></div>
      <div class="projects-container-heading">
        {{ "MATCHING_GIFT.title_matching_gift" | translate }}
      </div>
      <div class="projects-container-subheading" [style.color]="programInfo.color">
        {{ programInfo.company_name }} {{ "MATCHING_GIFT.subtitle1_matching_gift" | translate }} {{ programInfo.multiplication_factor }}.
        <span *ngIf="programInfo.premium_number >= 1">
          <br>
          {{ "MATCHING_GIFT.subtitle2_matching_gift" | translate }} {{ programInfo.premium_number }} {{ "MATCHING_GIFT.subtitle3_matching_gift" | translate }} {{ programInfo.premium_factor }} !
        </span>
      </div>
      <div class="project-wrapper" *ngFor="let project of programInfo.projects">
        <div class="project-image" [style.backgroundImage]="'url(' + project.picture_thumbnail + ')'"></div>
        <div class="project-info">
          <div class="project-north-star" [style.backgroundColor]="getRGBAColor(0.25)">{{ "LANDING." + project.north_star + "_landing" | translate }}</div>
          <div class="project-heading">{{project.title[currentLanguage]}}</div>
          <div class="project-subheading">{{ "BRAND_PAGE.by_brand_page" | translate }} {{ project.organization }}</div>
          <div class="project-desc" [innerHTML]="project.short_description[currentLanguage]"></div>
          <button class="project-action-button green sans-serif" (click)="chooseProject(project, target)" [style.backgroundColor]="programInfo.color">
            <img loading="lazy" src="/assets/icons/flash-white.svg" alt="flash">
            <span>{{ "MATCHING_GIFT.cta_matching_gift" | translate }} {{ project.organization }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="bottom-banner" [style.backgroundImage]="'url(' + programInfo.picture_cover + ')'"></div>

  <app-brand-footer [brandColor]="programInfo.color"></app-brand-footer>

</ng-container>
